import { FormEvent, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { loginAdmin } from './adminService';
import { useAdminSession } from './adminSession';
import styles from './Admin.module.scss';

function AdminLogin() {
  const navigate = useNavigate();
  const [session, setSession] = useAdminSession();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (session) {
      navigate('/admin');
    }
  }, [session, navigate]);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { token, admin } = await loginAdmin(username, password);
      setSession({ token, admin });
      navigate('/admin');
    } catch (err) {
      setError(err instanceof Error ? err.message : '로그인 중 오류가 발생했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className={styles.authPage}>
      <div className={styles.card}>
        <div className={styles.brandMark}>G</div>
        <h1>관리자 로그인</h1>
        <form className={styles.uploadForm} onSubmit={handleSubmit}>
          <label htmlFor="login-username">아이디</label>
          <input
            id="login-username"
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
          />

          <label htmlFor="login-password">비밀번호</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />

          <button type="submit" disabled={submitting}>
            {submitting ? '로그인 중...' : '로그인'}
          </button>
        </form>
        {error && <p className={styles.error}>{error}</p>}
        <p>
          <Link to="/admin/signup">관리자 계정이 없나요? 회원가입</Link>
        </p>
      </div>
    </section>
  );
}

export default AdminLogin;
